<template>
  <div id="app">
    <i-header></i-header>

    <div
      class="main"
      :style="{ minHeight: fullHeight+'px' }"
    >
      <router-view keep-alive></router-view>
    </div>

    <school-select :visible="!school"></school-select>

    <i-footer></i-footer>
  </div>
</template>

<script>
import iHeader from './components/Header';
import iFooter from './components/Footer';
import store from './vuex/store';
import { getSchool } from './vuex/getters';
import { userFetch, setTypes } from './vuex/actions';
import schoolSelect from './components/schoolSelect';
import api from './api';

export default {
  name: 'App',

  store,
  vuex: {
    actions: {
      userFetch,
      setTypes,
    },
    getters: {
      school: getSchool,
    },
  },

  components: {
    iHeader, iFooter,
    schoolSelect,
  },

  data () {
    return {
      fullHeight: document.documentElement.clientHeight,
    };
  },

  ready: function () {
    this.userFetch();
    this.getTagType();
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize () {
      this.fullHeight = document.documentElement.clientHeight;
    },
    getTagType () {
      return this.$http.get(api.tag.type)
        .then(res => {
          if (res.body) {
            this.setTypes(res.body);
          }
        });
    },
  },
};
</script>

<style lang="less">
@import "~normalize.css/normalize.css";
@import "./styles/w3.css";
@import "./styles/const.less";
@import "./styles/theme.less";
@import './styles/iconfont/iconfont.css';
// @import "~vue-swipe/dist/vue-swipe.css";

.w3-content {
    max-width: @centent-width;
    width: 100%;
}

.pc-only {
    @media screen and (max-width: 769px) {
        display: none !important;
    }
}

.mobile-only {
    @media screen and (min-width: 769px) {
        display: none !important;
    }
}

#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  width: 100%;
  position: relative;
  padding: 0;
  margin: 0;
  overflow: hidden;
  top: 0;
}

body, h1, h2, h3, h4, h5, h6 {
  font-family: 'Raleway', Arial, Helvetica, sans-serif
}

body{
    background-color: #e9e9e9;
    scroll-behavior: smooth;
}

.main {
  margin-top: 50px;
  overflow: hidden;
}

.card {
    background: #fff;
    border-radius: 4px;
    font-size: 14px;
    // overflow: hidden;

    box-shadow: 0 1px 0px rgba(0,0,0,.15);
    transition: box-shadow 0.3s ease;

    margin: 4px;
    padding: 5px;
    &:hover {
        box-shadow: 0 1.5px 1px rgba(0,0,0,.15);
    }
}

button[type="card"] {
    display: inline-block;
    border: none;
    outline: 0;
    text-align: center;

    &:not(:disabled) {
        cursor: pointer;
    }

    background: #fff;
    border-radius: 4px;
    font-size: 12px;

    box-shadow: 0 1px 0px rgba(0,0,0,.15);
    transition: box-shadow 0.3s ease;

    padding: 5px 10px;

    &:hover:not(:disabled) {
        box-shadow: 0 1.5px 1px rgba(0,0,0,.15);
    }

    &:active {
        box-shadow: 0 -1px 0px rgba(0,0,0,.15);
    }

    & > * {
        padding: 0 5px;
        vertical-align: middle;
        display: inline-block;
    }

    &:disabled {
        color: #aaa;
    }
}

.button-group {
    & > button[type="card"]:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        margin-right: 0;
    }
    & > button[type="card"]:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        margin-left: -2px;
    }
}

.breadcrumb {
    padding: 0 5px;
    font-weight: bold;

    .bread_item{
        color: #666;
        font-weight: bold;
        .ivu-breadcrumb-item-separator {
            color: #9F9F9F;
            font-weight: lighter;
            font-size: large;
        }
    }

    & > * {
        display: inline-block;
        vertical-align: middle;
        padding: 0 5px;
        font-size: 1.3em;
    }
    & > a {
        color: #666;
        // border-right: solid 1px #999;
        margin: 0;

        &:hover {
            color: @primary-color;
        }
    }
    .bread_div {
        font-weight: lighter;
        font-size: large;
        color: #9F9F9F;
    }

    @media screen and (max-width: 769px) {
        height: 40px;
        background: #fff;
        border-radius: 4px;
        margin: 3.75px 3.75px 3.75px 3.75px;
        line-height: 40px;

    }

}

.unselectable {
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;

    /*
    Introduced in IE 10.
    See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
    */
    -ms-user-select: none;
    user-select: none;
}

.hr-text {
    border-bottom: solid 1px #657180;

    height: 15px;

    text-align: center;
    span {
        padding: 10px 20px;
        font-size: 20px;
    }

    margin-bottom: 15px;
}
</style>




// WEBPACK FOOTER //
// App.vue?b6af71ec